<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div class="fullWidth" v-loading="loading">
        <ServiceInfo></ServiceInfo>
        <div class="col-lg-10 col-md-11 col-sm-12 m-auto jipvio-rad">
          <!-- 본인인증 -->
          <Identification
            ref="confirm"
            @ownerName="ownerName = $event"
            @ownerTel="ownerTel = $event"
            @ownerAddr="ownerAddr = $event"
            @ownerAddrDetail="ownerAddrDetail = $event"
          ></Identification>

          <!-- 매물 위치 정보 -->
          <LocationInfo
            ref="location"
            @SendLoactionInfo="GetloactionData"
            @loading="Loading"
          ></LocationInfo>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import ServiceInfo from "@/pages/jipvio/GeneralViews/ServiceInfo.vue";
import Identification from "@/pages/components/Jipvio/Step1_Identification.vue";
import LocationInfo from "@/pages/components/Jipvio/Step1_LocationInfo.vue";
import { createNamespacedHelpers, mapGetters } from "vuex";

import openApi from "@/service/openapi";

const {
  mapActions: sessionMapActions,
  mapGetters: sessionMapGetters
} = createNamespacedHelpers("loginSession");

import {
  Form,
  FormItem,
  Select,
  Loading,
  Message,
  Notification
} from "element-ui";

export default {
  components: {
    ServiceInfo,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Loading.name]: Loading,
    Identification,
    LocationInfo
  },

  data() {
    return {
      loading: false,
      //==================================
      ownerAddrInfo: {}, //소유주 주소 총정보
      ownerName: null, //소유주 이름
      ownerAddr: null, // 소유주 주소
      ownerAddrDetail: "", //소유주 상세주소
      ownerTel: null, // 소유주 휴대폰

      propertyRAddr: null, //매물 도로명 주소
      propertyLat: null, // 매물 위도
      propertyLong: null, // 매물 경도

      locationInfo: {}, // 매물 주소 총정보
      fullRAddr: null, //매물 full도로명
      fullJAddr: null, //매물 full지번

      // jipvioMarker: null,
      // jipvioMap: null,
      // jipvioGeocoder: null,

      dongDisable: false,
      hoDisable: false,

      allFloor: false,
      partFloor: false,
      partArea: null, // 직접입력한 면적
      hoTitle: null, // 직접입력한 호 명칭
      flrCheckShow: false, // 전체,일부 체크박스 Show 여부

      legalCode: null, //법정동 코드

      newBun: null, // for문으로 만든 bun
      newJi: null, // for문으로 만든 ji
      jiBun: null, // 지번주소의 지번
      legalDong: null, // 법정동

      brdList: [], // 용도지역 리스트

      //bdRegExposList: [], // 전유부 리스트
      genBdList: null, //총괄표제부
      bdList: [], //표제부 리스트
      selectedDongIdx: null, //선택된 동
      selectedBd: null, //해당 표제부

      hoList: [], //호 리스트
      selectedHo: null, // 선택된 호 index

      flrList: [], //층 리스트
      selectedFlr: null, //선택된 층수

      useArea: null, // 전용면적
      provArea: null, // 공급면적
      purpsDetail: null, // 주용도

      platGbCd: null, //대지구분코드

      isEtv: false // extraValidtation 에 걸렸는지
    };
  },
  created() {
    console.log("ler step1 created");
    this.bringData();
  },
  computed: {
    ...sessionMapGetters({
      sessionOwnerJuso: "getOwnerJuso",
      sessionTargetJuso: "getTargetJuso",
      sessionPropertyInquiry: "getPropertyInquiry"
    }),

    hhldCnt() {
      if (this.selectedBd.hhldCnt != 0) {
        return this.selectedBd.hhldCnt;
      } else if (this.selectedBd.hoCnt != 0) {
        return this.selectedBd.hoCnt;
      } else {
        return null;
      }
    },

    strct() {
      if (this.selectedBd.etcStrct != null) {
        return this.selectedBd.etcStrct;
      } else {
        return this.selectedBd.strctCdNm;
      }
    },

    buildYear() {
      if (this.selectedBd != null) {
        if (
          this.selectedBd.useAprDay != null &&
          this.selectedBd.useAprDay != undefined &&
          this.selectedBd.useAprDay != " "
        ) {
          return this.selectedBd.useAprDay.substring(0, 4);
        } else {
          return null;
        }
      } else {
        return null;
      }
    },

    modifiedUseAprDay() {
      if (this.selectedBd != null) {
        let UAD = this.selectedBd.useAprDay;
        if (UAD != null && UAD != undefined && UAD != " ") {
          return (
            UAD.substring(0, 4) +
            "-" +
            UAD.substring(4, 6) +
            "-" +
            UAD.substring(6, 8)
          );
        } else {
          return null;
        }
      } else {
        return null;
      }
    },

    dongNm() {
      if (this.selectedDongIdx == null) {
        return null;
      } else {
        return this.bdList[this.selectedDongIdx].dongNm;
      }
    },

    jpvTypeCd() {
      const purp = this.purpsDetail;
      if (purp.search("아파트") != -1) {
        return "APT";
      } else if (purp.search("다세대") != -1 || purp.search("연립") != -1) {
        return "VLL";
      } else if (
        purp.search("단독") != -1 ||
        purp.search("다중") != -1 ||
        purp.search("다가구") != -1
      ) {
        return "HOM";
      } else if (
        purp.search("오피스텔") != -1 ||
        purp.search("업무시설") != -1
      ) {
        return "OPS";
      } else {
        return null;
      }
    },

    platArea() {
      if (this.genBdList != null && this.selectedBd != null) {
        if (this.genBdList.length == 0) {
          return this.selectedBd.platArea;
        } else {
          return this.genBdList[0].platArea;
        }
      } else {
        return null;
      }
    },

    totParking() {
      if (this.genBdList != null && this.selectedBd != null) {
        if (this.genBdList.length == 0) {
          return (
            this.selectedBd.indrAutoUtcnt +
            this.selectedBd.indrMechUtcnt +
            this.selectedBd.oudrAutoUtcnt +
            this.selectedBd.oudrMechUtcnt
          );
        } else {
          return this.genBdList[0].totPkngCnt;
        }
      } else {
        return null;
      }
    },
    platGbCdNm() {
      if (this.platGbCd == 0) {
        return "대";
      } else if (this.platGbCd == 1) {
        return "산";
      } else if (this.platGbCd == 2) {
        return "블록";
      } else {
        return null;
      }
    } // 대지구분이름(0: 대,1:산 2:블록 )
  },

  watch: {},

  mounted() {},

  methods: {
    ...sessionMapActions(["savePropertyInquiryStep1"]),

    bringData() {
      console.log(this.sessionPropertyInquiry.certification);
      this.ownerName = this.sessionPropertyInquiry.certification.ownerName;
      this.ownerAddr = this.sessionPropertyInquiry.certification.ownerAddr;
      this.ownerAddrDetail = this.sessionPropertyInquiry.certification.ownerAddrDetail; //소유주 상세주소
      this.ownerTel = this.sessionPropertyInquiry.certification.ownerTel; // 소유주 휴대폰

      this.legalCode = this.sessionPropertyInquiry.certification.legalCode; //법정동 코드

      this.selectedBd = this.sessionPropertyInquiry.certification.selectedBd; //해당 표제부

      this.useArea = this.sessionPropertyInquiry.certification.useArea; // 전용면적
      this.provArea = this.sessionPropertyInquiry.certification.provArea; // 공급면적
      this.purpsDetail = this.sessionPropertyInquiry.certification.purpsDetail; // 주용도
      this.platGbCd = this.sessionPropertyInquiry.certification.platGbCd; //대지구분코드
    },

    /* 도로명 선택 할 경우 나오는 메세지 */
    notify: function() {
      Notification.warning({
        title: "Warning",
        message: "지번을 선택해 주세요"
      });
    },

    /* 자식으로 부터 loading함수 실행 */
    Loading() {
      this.loading = !this.loading;
    },

    GetloactionData(Info) {
      (this.propertyRAddr = Info.propertyRAddr),
        (this.propertyLat = Info.propertyLat),
        (this.propertyLong = Info.propertyLong),
        (this.selectedDongIdx = Info.selectedDongIdx),
        (this.genBdList = Info.genBdList),
        (this.bdList = Info.bdList),
        (this.hoList = Info.hoList),
        (this.selectedHo = Info.selectedHo),
        (this.flrList = Info.flrList),
        (this.selectedFlr = Info.selectedFlr),
        (this.legalDong = Info.legalDong),
        (this.allFloor = Info.allFloor),
        (this.partFloor = Info.partFloor),
        (this.partArea = Info.partArea),
        (this.hoTitle = Info.hoTitle),
        (this.flrCheckShow = Info.flrCheckShow),
        (this.brdList = Info.brdList),
        (this.newBun = Info.newBun),
        (this.newJi = Info.newJi),
        (this.jiBun = Info.jiBun),
        (this.legalDong = Info.legalDong),
        (this.locationInfo = Info.locationInfo),
        (this.fullRAddr = Info.fullRAddr),
        (this.fullJAddr = Info.fullJAddr),
        (this.dongDisable = Info.dongDisable),
        (this.hoDisable = Info.hoDisable);
    },
    bringComponetData() {
      this.$refs.location.SendInfo();
    },

    async saveStep1Info() {
      console.log("step1 Action!");
      this.loading = true;
      const propInfo = {
        // sigunguCd: this.locationInfo.admCd.substring(0, 5),
        // bjdongCd: this.locationInfo.admCd.substring(5, 10),
        sigunguCd: this.locationInfo.bcode.substring(0, 5) /* daum */,
        bjdongCd: this.locationInfo.bcode.substring(5, 10) /* duam */,
        bun: this.newBun,
        ji: this.newJi,
        dongNm: this.dongNm,
        hoNm: this.selectedHo,
        floor: this.selectedFlr
      };
      const res = await openApi.getPropDetailInfo(propInfo);

      if (res.status != 200) {
        this.loading = false;
        Message({
          message: "다시 시도해주세요.",
          type: "error"
        });
        return false;
      }

      this.useArea = res.payload.useArea;
      this.provArea = res.payload.provArea;

      if (res.payload.mainPurpsCdNm != null) {
        this.purpsDetail = res.payload.mainPurpsCdNm;
      } else {
        this.purpsDetail = res.payload.etcPurps;
      }

      // this.purpsDetail =
      //   res.payload.mainPurpsCdNm === "" || res.payload.mainPurpsCdNm === null
      //     ? res.payload.etcPurps
      //     : res.payload.mainPurpsCdNm;

      if (this.selectedDongIdx == null) {
        this.selectedBd = this.bdList[0];
      } else {
        this.selectedBd = this.bdList[this.selectedDongIdx];
      }
      this.platGbCd = Number(this.selectedBd.platGbCd);

      let certification = {
        ownerName: this.ownerName, //소유주 이름
        ownerAddr: this.ownerAddr, // 소유주 주소
        ownerAddrDetail: this.ownerAddrDetail, //소유주 상세주소
        ownerTel: this.ownerTel, // 소유주 휴대폰

        locationInfo: this.locationInfo, // 매물 주소 총정보

        // propertyJAddr: this.locationInfo.jibunAddr, //매물 지번주소
        propertyJAddr: this.locationInfo.jibunAddress /* duam */,
        propertyRAddr: this.propertyRAddr, //매물 도로명 주소
        propertyLat: this.propertyLat, //매물 위도
        propertyLong: this.propertyLong, //매물 경도

        AddrDong: this.dongNm, //동
        AddrHo: this.selectedHo, //호
        AddrFloor: this.selectedFlr, //층

        fullRAddr: this.fullRAddr, //주소+동호층 (도로명)
        fullJAddr: this.fullJAddr, //주소+동호층 (지번)

        dongDisable: this.dongDisable, //dong 없을 때 selectbox disable
        hoDisable: this.hoDisable, //ho 없을 때 selectbox disable
        flrCheckShow: this.flrCheckShow, // 층 관련 체크박스 show 여부
        allFloor: this.allFloor, //층 전체 체크박스
        partFloor: this.partFloor, //층 일부 체크박스
        partArea: parseFloat(Number(this.partArea).toFixed(2)), // 층 일부 직접 입력한 면적
        hoTitle: this.hoTitle, //층 일부인 경우 해당 공간 이름

        // legalCode: this.locationInfo.admCd, //법정동 코드
        legalCode: this.locationInfo.bcode /* duam */,

        newBun: this.newBun, //api를 위해 만든 번
        newJi: this.newJi, //api를 위해 만든 지
        jiBun: this.jiBun, // 지번주소의 지번
        legalDong: this.legalDong, // 법정동

        genBdList: this.genBdList,
        bdList: this.bdList,
        brdList: this.brdList, // 용도지역
        selectedBd: this.selectedBd,
        selectedDongIdx: this.selectedDongIdx,
        hoList: this.hoList,
        flrList: this.flrList,

        useArea: parseFloat(this.useArea.toFixed(2)), // 전용면적
        provArea: parseFloat(this.provArea.toFixed(2)), // 공급면적
        // bdNm: this.locationInfo.bdNm, //건물명
        bdNm: this.locationInfo.buildingName /* duam */,
        strct: this.strct, // 구조
        purpsDetail: this.purpsDetail, // 용도
        platArea: parseFloat(this.platArea.toFixed(2)), //대지면적
        totArea: parseFloat(this.selectedBd.totArea.toFixed(2)), //연면적
        buildYear: this.buildYear, //건축년도
        useAprDay: this.modifiedUseAprDay, //사용승인 일자
        hhldCnt: this.hhldCnt, //총 세대 수
        grndFlrCnt: this.selectedBd.grndFlrCnt, //지상 층 수

        totPkngCnt: this.totParking, // 총 주차대수
        jpvTypeCd: this.jpvTypeCd, // 집비오분류 매물유형(아파트, 빌라, 주택, 오피스텔)

        platGbCd: this.platGbCd, // 대지구분코드
        platGbCdNm: this.platGbCdNm // 대지구분코드명(0:대, 1:산, 2:블록)
      };
      this.savePropertyInquiryStep1(certification);
      console.log("======================sessionPropertyInquiry");
      console.log(this.sessionPropertyInquiry);
      this.loading = false;
    },

    /* 동,호수가 없는 경우 (예: 서울 구로구 경서로 39-5) */
    extraValidate() {
      this.isEtv = false;
      let errMsg = [];

      if (this.bdList.length > 1 && this.selectedDongIdx == null) {
        errMsg.push({
          message: "동을 선택해주세요"
        });
      }

      if (this.hoList.length > 0 && this.selectedHo == null) {
        errMsg.push({
          message: "호를 선택해주세요"
        });
      }

      if (
        this.flrCheckShow == true &&
        this.allFloor == false &&
        this.partFloor == false
      ) {
        errMsg.push({
          message: "전체 또는 일부를 선택해주세요"
        });
      }

      if (
        this.partFloor == true &&
        (this.partArea == null || this.partArea == "")
      ) {
        errMsg.push({
          message: "면적을 입력해주세요"
        });
      }

      if (
        this.partFloor == true &&
        (this.hoTitle == null || this.hoTitle == "")
      ) {
        errMsg.push({
          message: "명칭을 입력해주세요"
        });
      }

      if (errMsg.length > 0) {
        this.isEtv = true;
        for (let i = 0; i < errMsg.length; i++) {
          Message({
            message: errMsg[i]["message"],
            type: "error",
            offset: (i + 1) * 35
          });
        }
        this.$refs["location"].$el.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    },

    // showMessage(ValId) {
    //   if (ValId == "ownerNameVal") {
    //     return "본인인증 성명을 확인해주세요.";
    //   } else if (ValId == "ownerTelVal") {
    //     return "본인인증 휴대전화를 확인해주세요.";
    //   } else if (ValId == "ownerAddrVal") {
    //     return "소유지 주소를 입력해주세요";
    //   } else if (ValId == "ownerAddrDetailVal") {
    //     return "소유주 상세주소를 입력해주세요.";
    //   } else if (ValId == "propertyRAddrVal") {
    //     return "매물 주소를 입력해주세요.";
    //   } else if (ValId == "selectedFlrVal") {
    //     return "층을 선택해주세요.";
    //   }
    // },

    setError() {
      const form = this.$refs.form;
      const errors = Object.entries(form.errors)
        .map(([key, value]) => ({ key, value }))
        .filter(error => error["value"].length);

      for (let i = 0; i < errors.length; i++) {
        console.log(errors[i].key);
        if (errors[i].key == "ownerNameVal") {
          form.setErrors({ ownerNameVal: ["본인인증 성명을 확인해주세요."] });
        } else if (errors[i].key == "ownerTelVal") {
          form.setErrors({
            ownerTelVal: ["본인인증 휴대전화를 확인해주세요."]
          });
        } else if (errors[i].key == "ownerAddrVal") {
          form.setErrors({ ownerAddrVal: ["소유지 주소를 입력해주세요"] });
        } else if (errors[i].key == "ownerAddrDetailVal") {
          form.setErrors({
            ownerAddrDetailVal: ["소유주 상세주소를 입력해주세요."]
          });
        } else if (errors[i].key == "propertyRAddrVal") {
          form.setErrors({ propertyRAddrVal: ["매물 주소를 입력해주세요."] });
        } else if (errors[i].key == "selectedFlrVal") {
          form.setErrors({ selectedFlrVal: ["층을 선택해주세요."] });
        }
      }
    },

    validate() {
      return this.$refs.form.validate().then(async isValid => {
        this.setError();
        if (!isValid) {
          console.log(this.$refs.form);
          setTimeout(() => {
            // 에러가 발생한 부분만 Array로 만들기
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error["value"].length);

            console.log(errors);
            for (let i = 0; i < errors.length; i++) {
              Message({
                // message: this.showMessage(errors[i]["key"]),
                message: errors[i].value[0],
                type: "error",
                offset: (i + 1) * 35
              });
            }

            console.log(this.$refs.form.refs);
            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }, 100);
          return;
        }
        this.bringComponetData();
        this.extraValidate(); //동,호가 없을경우 필요한 검증

        if (this.isEtv) {
          return;
        }
        if ((await this.saveStep1Info()) == false) {
          return;
        }
        this.scrollToTop();
        this.$emit("on-validated", isValid);
        return isValid;
      });
    },
    //=================================================================
    scrollToTop() {
      window.scrollTo(0, 0);
    }
  }
};
</script>
<style>
/*div {
  font-size: 18px;
}*/
.jipvio-rad h3 {
  color: #797979;
  text-align: center;
}

.jipvio-rad h5,
h6 {
  color: #797979;
  font-size: 1em;
}

.pptInquiry_map_wrap {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 42%;
  padding-bottom: 42%;
  box-sizing: border-box;
  border: 1px solid #ddd;
}

.pptInquiry_map_inner {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
}
.el-input__inner {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.el-btn-height {
  height: 37px;
}

.fullWidth {
  width: 100%;
}

.fullHeight {
  height: 100%;
}

.addrSelectWidth {
  width: 88%;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* #partAreaBox {
  width: 65px;
  margin-right: 5px;
/* } 

/*
#hoTitleBox {
  width: 65px;
  margin-right: 5px;
}*/

div.jipvio-bg-white .el-input__inner[readonly] {
  background-color: #ffffff;
}
div.jipvio-bg-white .el-input__inner[disabled] {
  background-color: #e3e3e3;
}
</style>
